import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Card, Grid, Dropdown, Popup} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {
  inputFiltersOptions, outputFiltersOptions,
  typesOfGraphics, sortOptions,
} from '../../../common/dictionaries/kpis';
import {Actions} from '../../../common/actions';
import BarChart from './chart/bar';
import LineChart from './chart/line';
import PieChart from './chart/pie';
import ChartSectionModal from './modal/chartSection';

const optionsFilter = {...inputFiltersOptions, ...outputFiltersOptions};

class LineSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'initialDate': props.initialDate,
      'finalDate': props.finalDate,
      'filterTypeTmp': props.lineType === 'dispatched' ? 'dealer' : 'zone',
      'filterTypeSelected': props.lineType === 'dispatched' ? 'dealer' : 'zone',
      'typeOfGraphicTmp': typesOfGraphics[0].value,
      'typeOfGraphicSelected': typesOfGraphics[0].value,
      'sortType': 'alphabetically',
      'drillDown': false,
      'searchParam': '',
    };
    this.handleClearDrillDown = this.handleClearDrillDown.bind(this);
    this.changeSortType = this.changeSortType.bind(this);
  }

  componentDidMount() {
    const {lineType} = this.props;
    this.getLinesInfo();
    this.props.setSearchParamDetailKpi({'key': lineType, 'search': ''});
  }

  componentDidUpdate(prevProps, prevState) {
    const {initialDate, finalDate} = this.state;
    const newState = {};
    if (initialDate !== prevProps.initialDate) {
      newState.initialDate = prevProps.initialDate;
    }
    if (finalDate !== prevProps.finalDate) {
      newState.finalDate = prevProps.finalDate;
    }
    if (_.isEmpty(newState)) {
      return;
    }
    this.setState(newState, () => this.getLinesInfo());
  }

  getLinesInfo() {
    const {initialDate, finalDate} = this.state;
    const {lineType} = this.props;
    const {filterTypeSelected} = this.state;
    this.props.fetchLinesInfoWithDetail({initialDate, finalDate, lineType}, filterTypeSelected);
  }

  getFiltersTypes() {
    const {lineType} = this.props;
    if (lineType === 'dispatched') {
      return Object.keys(outputFiltersOptions).map((option) => {
        return {'text': outputFiltersOptions[option], 'value': option};
      });
    }
    return Object.keys(inputFiltersOptions).map((option) => {
      return {'text': inputFiltersOptions[option], 'value': option};
    });
  }

  changeFilterType(value) {
    const {lineType} = this.props;
    this.setState({'filterTypeTmp': value, 'search': '', 'drillDown': false}, () =>
      this.updateDataForFilterType()
    );
    this.props.setSearchParamDetailKpi({'key': lineType, 'search': ''});
  }

  changeSortType(event, {value}) {
    const {sortType} = this.state;
    if (sortType !== value) {
      this.setState({'sortType': value});
    }
  }

  updateDataForFilterType() {
    const {filterTypeSelected, filterTypeTmp} = this.state;
    const {lineType} = this.props;
    if (filterTypeSelected === filterTypeTmp) {
      return;
    }
    this.props.clearUrlLinesFile();

    const filterLabel = lineType === 'dispatched' ? outputFiltersOptions[filterTypeTmp] :
      inputFiltersOptions[filterTypeTmp];
    this.props.onFilterChange(lineType, filterTypeTmp, filterLabel);
    this.setState({'filterTypeSelected': filterTypeTmp}, () => this.getLinesInfo());
  }

  getTypesOfGraphics() {
    return typesOfGraphics.map((element) => {
      return {'text': element.name, 'value': element.value};
    });
  }

  changeTypeOfGraphic(value) {
    this.setState({'typeOfGraphicTmp': value}, () => this.updateDataForTypeOfGraphic());
  }

  updateDataForTypeOfGraphic() {
    const {typeOfGraphicSelected, typeOfGraphicTmp} = this.state;
    if (typeOfGraphicSelected !== typeOfGraphicTmp) {
      this.setState({'typeOfGraphicSelected': typeOfGraphicTmp});
    }
  }

  renderAverage() {
    const {average} = this.props;
    return (
      <Popup
        trigger={<span>{getNumericValue(average, 2)}</span>}
        position='top left'
        inverted
        content='Promedio'
      />
    );
  }

  renderSortSection() {
    const {typeOfGraphicSelected, sortType} = this.state;
    if (typeOfGraphicSelected === 'pie') {
      return null;
    }
    return (
      <Dropdown
        selection
        options={sortOptions}
        value={sortType}
        onChange={this.changeSortType}
      />
    );
  }

  handleDrillDownByUser = (name) => {
    const {initialDate, finalDate} = this.state;
    const {lineType} = this.props;
    const {filterTypeSelected} = this.state;
    if (filterTypeSelected !== '') {
      this.props.clearUrlLinesFile();
      this.props.fetchLinesInfoWithDetail({initialDate, finalDate, lineType}, filterTypeSelected, name);
      this.setState({'filterTypeSelected': '', 'drillDown': true, 'searchParam': name});
      this.props.setSearchParamDetailKpi({'key': lineType, 'search': name});
    }
  };

  handleClearDrillDown = () => {
    const {initialDate, finalDate} = this.state;
    const {lineType} = this.props;
    const {filterTypeTmp, drillDown} = this.state;

    if (drillDown) {
      this.props.clearUrlLinesFile();
      this.props.fetchLinesInfoWithDetail({initialDate, finalDate, lineType}, filterTypeTmp);
      this.setState({'filterTypeSelected': filterTypeTmp, 'drillDown': false});
      this.props.setSearchParamDetailKpi({'key': lineType, 'search': ''});
    }
  };

  sortData(data) {
    const {sortType} = this.state;
    if (sortType === 'numerically') {
      return _.orderBy(data, 'value', 'desc');
    }
    return data;
  }

  renderArrow(drillDown) {
    return !drillDown ? null : <p onClick={this.handleClearDrillDown}></p>;
  }

  renderSearchLabel(searchParam, filterTypeTmp) {
    return (
      <p className="search-label">
        Filtro por :{' '}
        <span>
          {searchParam ?
            `${optionsFilter[filterTypeTmp]} x  ${searchParam}` :
            ' ---- '}
        </span>
      </p>
    );
  }

  renderChartSection(data, handleDrillDownByUser) {
    if (!data || !data.length) {
      return (
        <div className='empty-chart'>No hay datos para generar el gráfico</div>
      );
    }
    const {typeOfGraphicSelected} = this.state;
    switch (typeOfGraphicSelected) {
      default:
      case 'bar':
        return (
          <BarChart data={data} handleDrillDownByUser={handleDrillDownByUser} />
        );
      case 'line':
        return (
          <LineChart data={data} handleDrillDownByUser={handleDrillDownByUser} />
        );
      case 'pie':
        return (
          <PieChart data={data} handleDrillDownByUser={handleDrillDownByUser} />
        );
    }
  }

  render() {
    const {lineLabel, numberLines, loadingLinesDetail, lineType, linesDetail, searchParam} = this.props;
    const {filterTypeTmp, typeOfGraphicTmp, typeOfGraphicSelected, drillDown} = this.state;
    const data = this.sortData(linesDetail[lineType]);

    return (
      <Card raised fluid>
        <div className='title-bar'>
          <div className='title gray-bg title-section-chart'>
            <h4>Número de líneas {lineLabel}</h4>
            <div className='title-bar-actions'>
              <h3>{getNumericValue(numberLines, 0)}&nbsp;/&nbsp;{this.renderAverage()}</h3>
            </div>
          </div>
          <div className='filters-section'>
            <Grid textAlign='left'>
              <Grid.Row>
                <Grid.Column width={2}>
                  <h4>Tipo Filtro</h4>
                </Grid.Column>
                <Grid.Column width={6}>
                  <Dropdown
                    selection
                    options={this.getFiltersTypes()}
                    search
                    value={filterTypeTmp}
                    disabled={loadingLinesDetail}
                    onChange={(e, {value}) => this.changeFilterType(value)}
                    placeholder='Tipo de filtro'
                  />
                </Grid.Column>
                <Grid.Column width={2}>
                  <h4>Tipo Gráfico</h4>
                </Grid.Column>
                <Grid.Column width={6}>
                  <Dropdown
                    selection
                    className='chart-type'
                    options={this.getTypesOfGraphics()}
                    search
                    value={typeOfGraphicTmp}
                    disabled={loadingLinesDetail}
                    onChange={(e, {value}) => this.changeTypeOfGraphic(value)}
                    placeholder='Tipo de gráfico'
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign='middle'>
                <Grid.Column width={2}>
                  <h4>{typeOfGraphicSelected === 'pie' ? '' : 'Ordenar '}</h4>
                </Grid.Column>
                <Grid.Column width={6}>{this.renderSortSection()}</Grid.Column>
                <Grid.Column width={6} textAlign='right'>
                  {this.renderArrow(drillDown)}
                </Grid.Column>
                <Grid.Column width={2} textAlign='right'>
                  <ChartSectionModal
                    data={data}
                    lineLabel={lineLabel}
                    typeOfGraphicSelected={typeOfGraphicSelected}
                    handleDrillDownByUser={this.handleDrillDownByUser}
                  />
                </Grid.Column>
                <Grid.Column width={16} textAlign='right'>
                  {this.renderSearchLabel(searchParam, filterTypeTmp)}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </div>
        {this.renderChartSection(data, this.handleDrillDownByUser)}
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'lineInfo': state.cpd.lineInfo,
    'loadingLinesDetail': state.cpd.loadingLinesDetail,
    'linesDetail': state.cpd.linesDetail,
    'searchParam': state.cpd.searchParam[ownProps.lineType],
  };
};

const {
  fetchLinesInfoWithDetail,
  clearUrlLinesFile,
  setSearchParamDetailKpi,
} = Actions;

export default connect(mapStateToProps, {
  fetchLinesInfoWithDetail,
  clearUrlLinesFile,
  setSearchParamDetailKpi,
})(LineSection);
